import { Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailDTO, RenaultAnimationActionRemuneration } from '../../../models/renault-animation-action-dto';
import { AnimationActionService } from 'src/app/services/animation-action.service';
import { RenaultMyServiceActionModel, RenaultMyServiceActionRemunerationList, RenaultMyServiceActionRemunerationModel } from 'src/app/models/renault-myservice-dto';
import { MyServiceService } from 'src/app/services/myservice.service';

@Component({
  selector: 'myservice-action-card',
  templateUrl: './myservice-action-card.component.html',
  styleUrls: ['./myservice-action-card.component.scss']
})
export class MyServiceActionCardComponent implements OnInit {

  @Input() model: RenaultMyServiceActionModel;
  @Input() showRemuneration: boolean = false;
  @Input() modelRemuneration: RenaultMyServiceActionRemunerationModel;


  constructor(private service: MyServiceService) { }

  ngOnInit(): void {

  }


}
